import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  recommendationSaveWithService: {
    description: 'show the user how much they can save if they used a certain service',
    defaultMessage: '<s>Save</s> <savings></savings> on this shipment by choosing {serviceName}',
    id: 't87eQT',
  },
  recommendationApplyButton: {
    description: 'Prompt for merchant to apply a rate recommendation to the shipment',
    defaultMessage: 'Apply & Save',
    id: '/q4kE3',
  },
  closeRateRecommendation: {
    defaultMessage: 'Close Rate Recommendation',
    description: 'Aria label for the close rate recommendation button',
    id: 'y30XK9',
  },
  recommendationSwitchBYOAtoWalletService: {
    description: 'show the user how much they can save if they used a certain service',
    defaultMessage: "<s>Save</s> <savings></savings> by using ShipStation's carrier rate for this shipment",
    id: '1wnBjL',
  },
  insuranceRecommendation: {
    description: 'Show the user how much they can save if they switch insurance providers',
    defaultMessage: '<s>Save</s> <savings></savings> on this shipment by choosing {insuranceProviderName} Insurance',
    id: '0jz0x2',
  },
  savingsDetectedTooltip: {
    description: 'show switch and save savings tooltip.',
    defaultMessage: 'Save <savings></savings> by switching to <b>{service}</b>.',
    id: 'ADmr/m',
  },
  savingsDetectedTooltipPreview: {
    description: 'show switch and save savings tooltip.',
    defaultMessage: '<savings></savings> in savings detected. {br} Click icon to view.',
    id: 'xmKzOM',
  },
  savingsAppliedTooltip: {
    description: 'show total saved when switch to suggested service.',
    defaultMessage: 'You saved <savings></savings>!',
    id: 'NW8Lon',
  },
  savingsDetectedAria: {
    description: 'show switch and save savings aria label.',
    defaultMessage: 'savings detected',
    id: '5/6Q8c',
  },
  bulkRecommendationBannerText: {
    description:
      'Text for a banner that shows the user how much money they can save on a certain number of shipments by applying the listed recommendations',
    defaultMessage: '<s>Save</s> {savingsAmount} on {recommendationCount} shipments by choosing {recommendationList}',
    id: 'gljmLZ',
  },
  rateShopper: {
    defaultMessage: 'Rate Shopper',
    description: 'Name for rate shopper recommendations displayed in the bulk recommendation banner',
    id: 'HtraWb',
  },
  applyingSavings: {
    defaultMessage: 'Applying savings...',
    description: 'Text displayed when savings are being applied',
    id: 'hNfEC+',
  },
  savingsApplied: {
    defaultMessage: 'You saved {savingsAmount}!',
    description: 'Amount saved by applying rate recommendations',
    id: 'a84j2t',
  },
});
